export const propRules = {
  rules: {
    heading: "Regras da acomodação",
    subheading:
      "Defina os horários de check-in e check-out que serão compartilhados com o hóspede durante o check-in.",
    cloneTitleNoun: "horários",
    cloneItemNoun: "os horários",
    bulkNoticePrefix:
      "Esta alteração será aplicada às {count} acomodações vinculadas a",
    checkinLabel: "Check-in",
    checkoutLabel: "Check-out",
    defaultCheckin: "Padrão 15:00",
    defaultCheckout: "Padrão 12:00",
    saving: "Salvando…",
    save: "Salvar",
    toasts: {
      loadError: "Não foi possível carregar os dados do anúncio.",
      bulkApplied: "Regras aplicadas a {count} acomodações",
      saveSuccess: "Regras salvas com sucesso",
      bulkPartialError: "Algumas acomodações não puderam ser atualizadas",
      saveError: "Erro ao salvar as regras",
    },
  },
  services: {
    cloneTitleNoun: "equipamentos e comodidades",
    cloneItemNoun: "os equipamentos e as comodidades",
    toasts: {
      saveSuccess: "Comodidades salvas com sucesso",
      saveError: "Erro ao salvar as comodidades",
    },
  },
  maintenance: {
    title: "Manutenção da acomodação",
    scopeProperty: "Acomodação inteira",
    scopeUnits: "Unidades específicas",
    selectUnits: "Selecionar unidades",
    dateFrom: "De",
    dateTo: "Até",
    closeArrivals: "Fechar chegadas (CTA)",
    closeDepartures: "Fechar saídas (CTD)",
    applying: "Aplicando...",
    apply: "Aplicar manutenção",
    removing: "Removendo...",
    remove: "Remover manutenção",
    toasts: {
      rangeScopeRequired:
        "Preencha o intervalo de datas e o escopo (unidades ou acomodação).",
      applied: "Manutenção aplicada.",
      applyError: "Erro ao aplicar a manutenção.",
      removed: "Manutenção removida.",
      removeError: "Erro ao remover a manutenção.",
    },
  },
  propMaintenance: {
    title: "Manutenção da acomodação",
    scopeProperty: "Acomodação inteira",
    scopeUnits: "Unidades específicas",
    selectUnits: "Selecionar unidades",
    dateFrom: "De",
    dateTo: "Até",
    closeArrivals: "Fechar chegadas (CTA)",
    closeDepartures: "Fechar saídas (CTD)",
    applying: "Aplicando...",
    apply: "Aplicar manutenção",
    removing: "Removendo...",
    remove: "Remover manutenção",
    toasts: {
      rangeScopeRequired:
        "Preencha o intervalo de datas e o escopo (unidades ou acomodação).",
      applied: "Manutenção aplicada.",
      applyError: "Erro ao aplicar a manutenção.",
      removed: "Manutenção removida.",
      removeError: "Erro ao remover a manutenção.",
    },
  },
};
